<label class="toggle-mode">{{theme ? 'Bright mode' : 'Dark mode'}}</label>
<label class="switch" [title]="theme ? 'Bright Mode' : 'Dark Mode'">
    <input type="checkbox" name="checkbox" [(ngModel)]="theme" (change)='changeTheme()'>
    <!-- <input type="checkbox" [(ngModel)]="isFppSelected" (click)="changeTheme()"> -->
    <span class="slider round"></span>
</label>
